import { useEffect, useState } from "react";

const MOBILE_QUERY = "(max-width: 767px)";

/** md altı: oyun paneli tam ekran sheet gibi davranır. */
export const useCompactViewport = () => {
  const [isCompact, setIsCompact] = useState(() =>
    typeof window === "undefined" ? false : window.matchMedia(MOBILE_QUERY).matches
  );

  useEffect(() => {
    const media = window.matchMedia(MOBILE_QUERY);
    const update = () => setIsCompact(media.matches);
    update();
    media.addEventListener("change", update);
    return () => media.removeEventListener("change", update);
  }, []);

  return isCompact;
};
